// extracted by mini-css-extract-plugin
module.exports = {"form_control":"TextArea_form_control__ujsKh","filled":"TextArea_filled__2jKWS","resize_y":"TextArea_resize_y__3wDad"};